import toBool from 'utils/toBool'
import { z } from 'zod'
import { GenericManagerSchema } from '../GenericManagerTask/GenericManagerSchema'

const managerSurgeryClinicalApprovalFields = z.object({
	surgeries: z.array(
		z
			.object({
				checked: z.boolean(),
				value: z
					.number()
					.transform((elem) => parseInt(elem, 10))
					.refine((elem) => elem >= 0, {
						message: 'must be a positive value',
						path: ['surgeries'],
					}),
				id: z.number(),
			})
			.strict()
	),
	exams: z
		.array(
			z
				.object({
					checked: z.boolean(),
					id: z.number(),
				})
				.strict()
		)
		.optional(),
	needEscort: z.boolean().optional().transform(toBool),
	medicalObservation: z.string().optional(),
})

const SurgeryClinicalApprovalFields = z.object({
	surgeries: z.array(
		z
			.object({
				checked: z.boolean(),
				value: z
					.number()
					.transform((elem) => parseInt(elem, 10))
					.refine((elem) => elem >= 0, {
						message: 'must be a positive value',
						path: ['surgeries'],
					}),
				id: z.number(),
			})
			.strict()
	),
	exams: z
		.array(
			z
				.object({
					checked: z.boolean(),
					id: z.number(),
				})
				.strict()
		)
		.optional(),
	notes: z.string().optional(),
	needEscort: z.boolean().optional().transform(toBool),
	urgency: z
		.string()
		.transform((elem) => parseInt(elem, 10))
		.refine((elem) => elem > 0 && elem < 4, {
			message: 'Invalid option',
			path: ['urgency'],
		}),
	medicalObservation: z.string().optional(),
})

export const strictSchema = (args) => {
	return SurgeryClinicalApprovalFields.refine(
		(data) => !args?.requestEscort || data?.needEscort !== undefined,
		{
			message: 'Required',
			path: ['needEscort'],
		}
	)
}

export const SurgeryClinicalApprovalSchema = (args) => strictSchema(args)

export const ExtendedSurgeryClinicalApprovalSchema = (args) =>
	z.intersection(
		GenericManagerSchema(args),
		managerSurgeryClinicalApprovalFields
	)
